module.exports = __webpack_public_path__ + "static/media/version.55d00bd9.png";